import React, { useState, useId } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export function CopyButton({ value, label, testid, className = "" }) {
  const [done, setDone] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(value || "");
    setDone(true);
    toast.success((label || "Value") + " copied");
    setTimeout(() => setDone(false), 1400);
  };
  return (
    <button
      data-testid={testid}
      onClick={copy}
      className={`inline-flex items-center justify-center rounded-md border border-slate-700 bg-slate-800/60 p-2 text-slate-300 transition-colors hover:border-emerald-500/60 hover:text-emerald-400 ${className}`}
      title="Copy"
    >
      {done ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />}
    </button>
  );
}

const STYLES = {
  accepted: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  partial: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  uncertain: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  verified: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  delivered: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  received: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30",
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  queued: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  failed: "bg-red-500/10 text-red-400 border-red-500/30",
  bounced: "bg-red-500/10 text-red-400 border-red-500/30",
  suspended: "bg-red-500/10 text-red-400 border-red-500/30",
  revoked: "bg-slate-600/20 text-slate-400 border-slate-600/40",
};

export function StatusPill({ status, testid }) {
  const id = useId();
  const cls = STYLES[status] || "bg-slate-600/20 text-slate-400 border-slate-600/40";
  return (
    <span data-testid={testid || `status-${id.replace(/:/g, "")}`} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full bg-current ${status === "pending" ? "pulse-dot" : ""}`} />
      {status}
    </span>
  );
}

export function CodeBlock({ children, testid }) {
  return (
    <div className="flex items-start justify-between gap-2 rounded-lg border border-slate-800 bg-slate-950 p-3">
      <code data-testid={testid} className="mono break-all text-xs leading-relaxed text-emerald-400">{children}</code>
    </div>
  );
}
